"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ProgressBar.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ProgressBar = function ProgressBar(_ref) {
  var value = _ref.value,
      baseColor = _ref.baseColor,
      progressColor = _ref.progressColor;
  var width = value;
  if (value < 0) width = 0;
  if (value > 100) width = 100;
  var progressStyle = {
    width: "".concat(width, "%"),
    backgroundColor: progressColor
  };
  var barStyle = {
    backgroundColor: baseColor
  };
  return _react.default.createElement("div", {
    className: "progress-bar",
    style: barStyle
  }, _react.default.createElement("span", {
    className: "progress-bar__value",
    style: progressStyle
  }));
};

ProgressBar.defaultProps = {
  value: 0,
  baseColor: '#c7c7c7',
  progressColor: '#555555'
};
ProgressBar.propTypes = {
  /** Porcentagem da barra */
  value: _propTypes.default.number,

  /** Cor da barra de fundo */
  baseColor: _propTypes.default.string,

  /** Cor da barra de progresso */
  progressColor: _propTypes.default.string
};
var _default = ProgressBar;
exports.default = _default;